import axios from 'axios';

const request = axios
    .get('data/text/intro.txt', { responseType: 'text/plain' })
	.then(resp => resp.data.split(/\n/g));

export default {

    getIntro () {
        return request;
    }

}